import { rectFromPoints, type Point, type Rect } from '@st/geom'

export function constrainPageRectMove(rect: Rect, pageBounds: Rect): Rect {
  return {
    ...rect,
    x: Math.max(pageBounds.x, Math.min(rect.x, pageBounds.x + pageBounds.width - rect.width)),
    y: Math.max(pageBounds.y, Math.min(rect.y, pageBounds.y + pageBounds.height - rect.height))
  }
}

export function constrainPageRectResize(rect: Rect, pageBounds: Rect): Rect {
  const topLeft: Point = {
    x: Math.max(rect.x, pageBounds.x),
    y: Math.max(rect.y, pageBounds.y)
  }
  const bottomRight: Point = {
    x: Math.min(rect.x + rect.width, pageBounds.x + pageBounds.width),
    y: Math.min(rect.y + rect.height, pageBounds.y + pageBounds.height)
  }
  return rectFromPoints(topLeft, bottomRight)
}
